import { useAppDispatch } from "@/store";
import { modalDispatcher } from "@/store/slices/modal-slice";
import HPinputModal from "@components/common/HPInputModal";

interface CreateDatasetModalProps {
  action: () => void;
}

const CreateDatasetModal: React.FC<CreateDatasetModalProps> = ({ action }) => {
  const dispatch = useAppDispatch();
  const { closeTopModal } = modalDispatcher(dispatch);

  return (
    <HPinputModal
      title="New dataset"
      cancelButtonText="Cancel"
      confirmButtonText="Create"
      headerIcon={<i className="fas fa-database"></i>}
      confirmButtonIcon={<i className="fas fa-check"></i>}
      loading={false}
      onConfirm={action}
      onCancel={closeTopModal}
      withDescription
    />
  );
};

export default CreateDatasetModal;
